import { Component } from 'react'

export default class SalesGoals extends Component {
	render() {
		return <div className="page-content">SalesGoals</div>
	}
}
